import GhostGuard from "middleware/GhostGuard";
import LoginModalRedirect from "app/pages/Auth/LoginModalRedirect";

const ghostRoutes = {
  id: "ghost",
  Component: GhostGuard,
  children: [
    // /login no longer renders the old standalone page — it just opens the
    // global auth modal (same one used everywhere else) and bounces away.
    // Kept outside AuthLayout so the old HeroScene layout never even mounts.
    {
      path: "login",
      Component: LoginModalRedirect,
    },
    {
      id: "auth-layout",
      lazy: async () => ({
        Component: (await import("app/pages/Auth/AuthLayout")).default,
      }),
      children: [
        {
          path: "register",
          lazy: async () => ({
            Component: (await import("app/pages/Auth/Signup")).default,
          }),
        },
      ],
    },
  ],
};

export { ghostRoutes }; 